<app-payment-qr *ngIf="english"></app-payment-qr>
<app-payment-qr-hindi *ngIf="hindi"></app-payment-qr-hindi>